/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export { default as createColorRamp } from './createColorRamp';
export { default as createTheme } from './createTheme';
export { default as createThemedComponent } from './createThemedComponent';
export { default as fontSizeBase } from './fontSizeBase';
export { default as mapComponentThemes } from './mapComponentThemes';
export { default as mineralTheme } from './mineralTheme';
export { default as ThemeProvider } from './ThemeProvider';



// WEBPACK FOOTER //
// ./src/themes/index.js